var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Router, } from '@angular/router';
import { PermissionType } from '@synisys/idm-authorization-client-js';
import { DePermissionService, } from '@synisys/idm-de-service-client-js';
import { FormService, FormType, } from '@synisys/idm-dynamic-layout-interpreter';
import { isNaN, isNil } from 'lodash';
import { DePermissionGuard } from '../de-permission.guard';
import { map, switchMap } from 'rxjs/operators';
var OnlineDePermissionGuard = /** @class */ (function (_super) {
    __extends(OnlineDePermissionGuard, _super);
    function OnlineDePermissionGuard(dePermissionService, router, formService) {
        var _this = _super.call(this) || this;
        _this.dePermissionService = dePermissionService;
        _this.router = router;
        _this.formService = formService;
        return _this;
    }
    OnlineDePermissionGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        var systemName = route.params.categoryName;
        var formName = route.params.formName;
        var permissionType = route.data.categoryPermissionType;
        var formId = !isNaN(Number(route.params.formId))
            ? Number(route.params.formId)
            : undefined;
        var instanceId = route.params.id;
        if (permissionType === undefined && (formId || formId === 0)) {
            // in view/edit forms we can't get permission type from route
            return this.formService
                .loadFormTypeId(formName, formId, systemName)
                .pipe(switchMap(function (type) {
                return _this.hasPermissionBy(systemName, _this.getPermissionType(type), instanceId);
            }));
        }
        else {
            return this.dePermissionService.hasCreatePermissionByCategory(systemName);
        }
    };
    OnlineDePermissionGuard.prototype.hasPermissionBy = function (systemName, permissionType, instanceId) {
        var _this = this;
        return this.dePermissionService
            .getCategoryDePermissionsByInstance(systemName, instanceId)
            .pipe(map(function (dePermission) {
            var hasPermission = _this.extractPermissionFrom(dePermission, permissionType);
            if (!hasPermission) {
                _this.router.navigate([
                    'dynamic-de/no-permission',
                    _this.getPermissionNameFrom(permissionType),
                ]);
            }
            return hasPermission;
        }));
    };
    OnlineDePermissionGuard.prototype.getPermissionType = function (formType) {
        switch (formType) {
            case FormType.EDIT:
                return PermissionType.EDIT;
            case FormType.VIEW:
                return PermissionType.VIEW;
            default:
                throw new Error('Unknown form type!!!');
        }
    };
    OnlineDePermissionGuard.prototype.getPermissionNameFrom = function (permissionType) {
        switch (permissionType) {
            case PermissionType.ADD:
                return 'add';
            case PermissionType.VIEW:
                return 'view';
            case PermissionType.EDIT:
                return 'edit';
            case PermissionType.DELETE:
                return 'delete';
            default:
                throw new Error('Unknown category permission type!!!');
        }
    };
    OnlineDePermissionGuard.prototype.extractPermissionFrom = function (dePermission, permissionType) {
        switch (permissionType) {
            case PermissionType.ADD:
                return dePermission.canCreate;
            case PermissionType.VIEW:
                return dePermission.canView;
            case PermissionType.EDIT:
                return dePermission.canEdit;
            case PermissionType.DELETE:
                return dePermission.canDelete;
        }
    };
    OnlineDePermissionGuard.prototype.isAtSameUrl = function (currentState, nextState) {
        if (!isNil(nextState)) {
            return (nextState.url.split('#')[0] === currentState.url.split('#')[0]);
        }
        return false;
    };
    OnlineDePermissionGuard = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [DePermissionService,
            Router,
            FormService])
    ], OnlineDePermissionGuard);
    return OnlineDePermissionGuard;
}(DePermissionGuard));
export { OnlineDePermissionGuard };
//# sourceMappingURL=online-de-permission.guard.js.map